import React from 'react';
import Dashboard from './dashboard/dashboard_main.jsx';
import "./style/global.scss";
const App = () => {
    return <Dashboard />
}

export default App; 